"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("../Button"));
var FormatText_1 = __importDefault(require("../FormatText"));
var hooks_1 = require("../../hooks");
var RelativeRouteContext_1 = __importDefault(require("../../contexts/RelativeRouteContext"));
var pathUtils_1 = require("../../helpers/pathUtils");
var RouterBackButton = function (props) {
    var onClick = props.onClick, buttonProps = __rest(props, ["onClick"]);
    var history = hooks_1.useRouter().history;
    var parentUrl = react_1.useContext(RelativeRouteContext_1.default).parentUrl;
    var url = hooks_1.useRouter().match.url;
    var handleClick = function (e) {
        if (parentUrl.length > 0) {
            history.push(parentUrl);
        }
        else {
            history.push(pathUtils_1.resolveRelativePath(url, '../'));
        }
        if (onClick)
            onClick(e);
    };
    return (react_1.default.createElement(Button_1.default, __assign({ icon: "arrows-back", responsive: true, onClick: handleClick }, buttonProps),
        react_1.default.createElement(FormatText_1.default, { id: "ui.commons.back", uppercase: true })));
};
exports.default = RouterBackButton;
